import { defineStore } from "pinia";
import { scbAxiosInstance, axiosInstance } from "../services";
import {useAlertStore, useMetaStore, loaderStore} from "../stores";
import { defaultError} from "../static/index"
import configuration from "../config.json"
var baseurl;
var axios;
var data;
export const useAuth = defineStore({
  id: "authStore",
  state: () => ({
      user: "",
      profile: "",
      dialog: false,
      forgotPasswordDialog: false,
      passwordOTPDialog: false,
      forgotPasswordUser: "",
      otpLoginMobile: '',
      changePasswordDialog: false,
      otpLoginDialog: false,
      createPasswordDialog: false,
      profileDialog: false,
      transactionToken: ""
  }),

  actions: {
    signOut(invalidToken = false, showMsg = true) {
      this.user = ""
      const alertStore = useAlertStore();
      if(invalidToken) {
        alertStore.setAlertMessage('error', 'Session has been expired.', true)
      } else if(showMsg) {
        alertStore.setAlertMessage('success', 'Signed out successfully.', true)
      }
    },
    setUser(user = {}) {
      this.user = user;
    },
    setProfileDetails(profile = {}){
      this.profile = profile;
    },
    setOtpLoginDialog(value) {
      this.otpLoginDialog = value;
    },

    setProfileDialog(value) {
      this.profileDialog = value;
    },

    setChangePasswordDialog(value) {
      this.changePasswordDialog = value;
    },

    setCreatePasswordDialog(value) {
      this.createPasswordDialog = value;
    },

    setForgotPasswordUser(value) {
      this.forgotPasswordUser = value
    },

    setLoginDialog(value) {
      this.dialog = value
    },

    setPasswordOTPDialog(value) {
      this.passwordOTPDialog = value
    },

    setForgotPasswordDialog(value) {
      this.forgotPasswordDialog = value
    },

    setTransactionToken(value) {
      this.transactionToken = value
    },
    
    resendLoginOtp() {
      const alertStore = useAlertStore();
      scbAxiosInstance.post("/api/users/resend_otp", { mobile_number: this.forgotPasswordUser, "request_type": "reset_password" })
      .then((res) => {
        if (res.status === 200) {
          this.setOtpLoginDialog(true)
          this.setLoginDialog(false)
          this.setForgotPasswordUser(mobile)
          alertStore.setAlertMessage('success', res?.data?.message, true)
        }
      }).catch(err => {
        alertStore.setAlertMessage('error', err?.response?.data?.message || defaultError, true)
      })
    },
    mobileSignIn(mobile) {
      const alertStore = useAlertStore();
      const metaStore = useMetaStore();
      
      if(metaStore.marketplaceContent === 'private' || configuration.new_signin.enabled){
        baseurl = "/api/users/send_sign_in_otp"
        axios = axiosInstance
        data = {
          mobile: mobile
        }
      }else{
        baseurl = "/api/users/send_login_otp"
        axios = scbAxiosInstance
        data = {
          mobile_number: mobile
        }
      }
      return axios.post(baseurl, data)
      .then((res) => {
        if (res.status === 200) {
          // this.setOtpLoginDialog(true)
          // this.setLoginDialog(false)
          this.setForgotPasswordUser(mobile)
          this.setTransactionToken(res?.data?.transaction_token)
          alertStore.setAlertMessage('success', res?.data?.message, true)
        }
        return res;
      }).catch(err => {
        if(metaStore.marketplaceContent === 'private' || configuration.new_signin.enabled){
          alertStore.setAlertMessage('error', err?.response?.data?.errors || defaultError, true)
        }else {
          alertStore.setAlertMessage('error', err?.response?.data?.message || defaultError, true)
        }
      })
    },
    signIn(details) {
      const loaderState = loaderStore()
      const alertStore = useAlertStore();
      const metaStore = useMetaStore();
      if(metaStore.marketplaceContent === 'private' || configuration.new_signin.enabled){
        baseurl = "/api/users/sign_in"
        axios = axiosInstance
      }else{
        baseurl = "/api/buyers/sign_in"
        axios = scbAxiosInstance
      }
      axios.post(baseurl, { login_params: details })
      .then((res = {}) => {
        loaderState.setLoading(false, []);
        if (res.status === 200) {
          this.user = res.data.user
          alertStore.setAlertMessage('success', 'Signed in successfully.', true)
        }
      }).catch(err => {
        loaderState.setLoading(false, []);
        if(metaStore.marketplaceContent === 'private' || configuration.new_signin.enabled){
          alertStore.setAlertMessage('error', err?.response?.data?.errors, true)
        }else {
          alertStore.setAlertMessage('error', err?.response?.data?.error, true)
        }
      })
    }
  },

  persist: {
    paths: ["user"]
  }
})
